import { NEWBUILDING_ADFOX_SITE_JK_DESKTOP } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';

export const selectBuilderLinkExperimentActive = (state: IApplicationState) => {
  const { experiments } = state;

  return isAbUseExperimentActive(experiments, NEWBUILDING_ADFOX_SITE_JK_DESKTOP, 'enabled');
};
